module.exports = __webpack_public_path__ + "f11791de9d1f3a0fc3ee6fd4470200a2.svg";